<template>
  <div id="bod" class="pt-5">
    <div>
      <div class="flex flex-col text-center justify-center items-start">
        <h1 class="text-primary mb-4 text-xl lg:text-4xl font-semibold">
          My Current Votes
        </h1>

        <div
          v-if="!selectedVotes.bod.length && !selectedVotes.elecom.length && !selectedVotes.audit.length"
          class="w-full my-24 italic text-grey text-center"
        >
          -- No votes selected yet --
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-6 w-full">
              <!-- Board of Directors - Officer Category -->
              <div class="bg-gray-100 rounded w-full" v-if="bodOfficerVotes.length">
                <div
                  class="rounded-t-2xl bg-primary px-4 py-3 lg:px-8 lg:py-5 text-left relative cursor-pointer"
                  @click="$emit('bod')"
                >
                  <img src="@/assets/images/papsi_edit_icon_white.svg" class="w-5 h-5 lg:w-8 lg:h-8 absolute top-[0.5rem] right-[0.5rem] lg:top-[1rem] lg:right-[1rem]" />
                  <h3 class="text-white text-lg lg:text-2xl">Board of Directors</h3>
                  <p class="text-white text-sm lg:text-xl">Officer Category (3)</p>
                </div>
      
                <div class="rounded-b-xl bg-gray-100 px-4 lg:px-8 text-left">
                  <div
                    v-for="vote in bodOfficerVotes"
                    :key="vote.code"
                    class="bg-gray-50 flex flex-row items-center p-3 lg:p-10 rounded-xl border-2 my-4 lg:my-8"
                  >
                    <img
                      v-if="vote.image"
                      :src="vote.image"
                      class="w-10 h-10 lg:w-20 lg:h-20 rounded-full mr-2 lg:mr-5 object-cover border"
                    />
                    <img
                      v-else
                      src="https://resource.pafcpic.net/assets/ga/papsi_placeholder.jpg"
                      class="w-10 h-10 lg:w-20 lg:h-20 rounded-full mr-2 lg:mr-5 object-cover border"
                    />
                    <p class="leading-tight text-base lg:text-2xl font-medium">
                      {{ vote.name }}
                    </p>
                  </div>
                </div>
              </div>
      
              <!-- Board of Directors - Enlisted Personnel Category -->
              <div class="bg-gray-100 rounded w-full" v-if="bodEpVotes.length">
                <div
                  class="rounded-t-2xl bg-primary px-4 py-3 lg:px-8 lg:py-5 text-left relative cursor-pointer"
                  @click="$emit('bod')"
                >
                  <img src="@/assets/images/papsi_edit_icon_white.svg" class="w-5 h-5 lg:w-8 lg:h-8 absolute top-[0.5rem] right-[0.5rem] lg:top-[1rem] lg:right-[1rem]" />
                  <h3 class="text-white text-lg lg:text-2xl">Board of Directors</h3>
                  <p class="text-white text-sm lg:text-xl">Enlisted Personnel Category (3)</p>
                </div>
      
                <div class="rounded-b-xl bg-gray-100 px-4 lg:px-8 text-left">
                  <div
                    v-for="vote in bodEpVotes"
                    :key="vote.code"
                    class="bg-gray-50 flex flex-row items-center p-3 lg:p-10 rounded-xl border-2 my-4 lg:my-8"
                  >
                    <img
                      v-if="vote.image"
                      :src="vote.image"
                      class="w-10 h-10 lg:w-20 lg:h-20 rounded-full mr-2 lg:mr-5 object-cover border"
                    />
                    <img
                      v-else
                      src="https://resource.pafcpic.net/assets/ga/papsi_placeholder.jpg"
                      class="w-10 h-10 lg:w-20 lg:h-20 rounded-full mr-2 lg:mr-5 object-cover border"
                    />
                    <p class="leading-tight text-base lg:text-2xl font-medium">
                      {{ vote.name }}
                    </p>
                  </div>
                </div>
              </div>
      
              <!-- Board of Directors - Civilian Category -->
              <div class="bg-gray-100 rounded w-full" v-if="bodCivilianVotes.length">
                <div
                  class="rounded-t-2xl bg-primary px-4 py-3 lg:px-8 lg:py-5 text-left relative cursor-pointer"
                  @click="$emit('bod')"
                >
                <img src="@/assets/images/papsi_edit_icon_white.svg" class="w-5 h-5 lg:w-8 lg:h-8 absolute top-[0.5rem] right-[0.5rem] lg:top-[1rem] lg:right-[1rem]" />
                  <h3 class="text-white text-lg lg:text-2xl">Board of Directors</h3>
                  <p class="text-white text-sm lg:text-xl">Civilian Category (2)</p>
                </div>
      
                <div class="rounded-b-xl bg-gray-100 px-4 lg:px-8 text-left">
                  <div
                    v-for="vote in bodCivilianVotes"
                    :key="vote.code"
                    class="bg-gray-50 flex flex-row items-center p-3 lg:p-10 rounded-xl border-2 my-4 lg:my-8"
                  >
                    <img
                      v-if="vote.image"
                      :src="vote.image"
                      class="w-10 h-10 lg:w-20 lg:h-20 rounded-full mr-2 lg:mr-5 object-cover border"
                    />
                    <img
                      v-else
                      src="https://resource.pafcpic.net/assets/ga/papsi_placeholder.jpg"
                      class="w-10 h-10 lg:w-20 lg:h-20 rounded-full mr-2 lg:mr-5 object-cover border"
                    />
                    <p class="leading-tight text-base lg:text-2xl font-medium">
                      {{ vote.name }}
                    </p>
                  </div>
                </div>
              </div>
      
              <!-- Audit Committee -->
              <div class="bg-gray-100 rounded w-full" v-if="auditVotes.length">
                <div
                  class="rounded-t-2xl bg-dark-blue px-4 py-3 lg:px-8 lg:py-5 text-left relative cursor-pointer"
                  @click="$emit('audit')"
                >
                  <img src="@/assets/images/papsi_edit_icon_white.svg" class="w-5 h-5 lg:w-8 lg:h-8 absolute top-[0.5rem] right-[0.5rem] lg:top-[1rem] lg:right-[1rem]" />
                  <h3 class="text-white text-lg lg:text-2xl">Audit Committee</h3>
                  <p class="text-white text-sm lg:text-xl">(2)</p>
                </div>
      
                <div class="rounded-b-xl bg-gray-100 px-4 lg:px-8 text-left">
                  <div
                    v-for="vote in auditVotes"
                    :key="vote.code"
                    class="bg-gray-50 flex flex-row items-center p-3 lg:p-10 rounded-xl border-2 my-4 lg:my-8"
                  >
                    <img
                      v-if="vote.image"
                      :src="vote.image"
                      class="w-10 h-10 lg:w-20 lg:h-20 rounded-full mr-2 lg:mr-5 object-cover border"
                    />
                    <img
                      v-else
                      src="https://resource.pafcpic.net/assets/ga/papsi_placeholder.jpg"
                      class="w-10 h-10 lg:w-20 lg:h-20 rounded-full mr-2 lg:mr-5 object-cover border"
                    />
                    <p class="leading-tight text-base lg:text-2xl font-medium">
                      {{ vote.name }}
                    </p>
                  </div>
                </div>
              </div>
      
              <!-- Election Committee -->
              <div class="bg-gray-100 rounded w-full" v-if="elecomVotes.length">
                <div
                  class="rounded-t-2xl bg-light-blue px-4 py-3 lg:px-8 lg:py-5 text-left relative cursor-pointer"
                  @click="$emit('elecom')"
                >
                  <img src="@/assets/images/papsi_edit_icon_white.svg" class="w-5 h-5 lg:w-8 lg:h-8 absolute top-[0.5rem] right-[0.5rem] lg:top-[1rem] lg:right-[1rem]" />
                  <h3 class="text-white text-lg lg:text-2xl">Election Committee</h3>
                  <p class="text-white text-sm lg:text-xl">Civilian Category (1)</p>
                </div>
      
                <div class="rounded-b-xl bg-gray-100 px-4 lg:px-8 text-left">
                  <div
                    v-for="vote in elecomVotes"
                    :key="vote.code"
                    class="bg-gray-50 flex flex-row items-center p-3 lg:p-10 rounded-xl border-2 my-4 lg:my-8"
                  >
                    <img
                      v-if="vote.image"
                      :src="vote.image"
                      class="w-10 h-10 lg:w-20 lg:h-20 rounded-full mr-2 lg:mr-5 object-cover border"
                    />
                    <img
                      v-else
                      src="https://resource.pafcpic.net/assets/ga/papsi_placeholder.jpg"
                      class="w-10 h-10 lg:w-20 lg:h-20 rounded-full mr-2 lg:mr-5 object-cover border"
                    />
                    <p class="leading-tight text-base lg:text-2xl font-medium">
                      {{ vote.name }}
                    </p>
                  </div>
                </div>
              </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import mixin from '@/mixin';

export default {
  name: "v-modal",
  mixins: [mixin],
  emits: ['bod', 'audit', 'elecom'],
  props: {
    is_visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    selectedVotesCodes() {
      return this.$store.state.selectedVotes;
    },
    gaCandidates() {
      return this.$store.state.gaCandidates || { bod: [], elecom: [], audit: [] };
    },
    selectedVotes() {
      const candidates = this.gaCandidates;
      return {
        bod: this.selectedVotesCodes.bod.map(code => {
          const candidate = candidates.bod.find(c => c.code === code) || { code, name: 'Unknown', type: '', photo: '' };
          return { ...candidate, image: candidate.photo };
        }),
        elecom: this.selectedVotesCodes.elecom.map(code => {
          const candidate = candidates.elecom.find(c => c.code === code) || { code, name: 'Unknown', type: '', photo: '' };
          return { ...candidate, image: candidate.photo };
        }),
        audit: this.selectedVotesCodes.audit.map(code => {
          const candidate = candidates.audit.find(c => c.code === code) || { code, name: 'Unknown', type: '', photo: '' };
          return { ...candidate, image: candidate.photo };
        }),
      };
    },
    bodOfficerVotes() {
      return this.selectedVotes.bod.filter(v => v.type === 'OFFICER');
    },
    bodEpVotes() {
      return this.selectedVotes.bod.filter(v => v.type === 'ENLISTED PERSONNEL');
    },
    bodCivilianVotes() {
      return this.selectedVotes.bod.filter(v => v.type === 'CIVILIAN');
    },
    auditVotes() {
      return this.selectedVotes.audit;
    },
    elecomVotes() {
      return this.selectedVotes.elecom;
    }
  },
  mounted() {
    this.scrollToSection();
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    scrollToSection() {
      // Map routes to respective section IDs
      const routeToSection = {
        "/board-of-directors": "bod",
        "/audit-supervisory-committee": "audit",
        "/election-committee": "elecom-ep",
      };

      // Get the section ID based on the route path
      const sectionId = routeToSection[this.$route.path];

      if (sectionId) {
        this.$nextTick(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.papsi-modal-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: end;
  background-color: rgba(0, 0, 0, 0.7);
}
</style>